import { useQuery } from '@tanstack/react-query';
import vlqrApi, { handleError } from 'utils/vlqrApi';

const useVoiceTranscriptionsForActivity = (activityId) => {
    const { data, refetch, isLoading, isError } = useQuery({
        queryKey: ['voiceTranscriptions', activityId],
        queryFn: () => getVoiceTranscriptions(activityId)
    });

    return { data, refetch, isLoading, isError };
};

const getVoiceTranscriptions = async (activityId) => {
    const { data } = await vlqrApi.get(`VoiceTranscriptions/${activityId}/VoiceTranscriptions`)
        .catch((error) => {
            handleError(error);
        });
    return data;
};

export default useVoiceTranscriptionsForActivity;